export enum AnnotationModeType {
  Add,
  Intersect,
  New,
  Subtract,
}
